export default {"src":"/_next/static/image/components/ui/Icon/icons/person.6320f8ee32aa2cb50411362268c7a7fd.svg","height":9,"width":8};